import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-link',
  templateUrl: './card-link.component.html',
  styleUrls: ['./card-link.component.scss'],
})
export class CardLinkComponent implements OnInit {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() imgPath: string;
  @Input() block: boolean = false;
  @Input() tag: string;
  @Input() description: string;
  @Input() isModal: boolean;
  @Input() link: string;

  constructor() {}

  ngOnInit(): void {}
}
